const SHOPIFY_UTILS = (() => {
  /**
  * @returns the current shopify cart
  */
  async function getShopifyCart() {
    const shopifyResponse =await fetch(`${window.Shopify.routes.root}cart.json`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return shopifyResponse.json();
  }

  /**
  * Adds the item to the shopify cart
  */
  async function addToShopifyCart({
    variantId
  }) {
    try {
      if (!variantId) {
        throw new Error('No variantId provided to add to cart');
      }
      const formData = {
        items: [{
          id: variantId,
          quantity: 1,
        }],
      };

      const shopifyResponse =  await fetch(`${window.Shopify.routes.root}cart/add.json`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const shopifyData = await shopifyResponse.json();

      if (shopifyData.errors) {
        throw new Error(`Cart error ${shopifyData.errors}`);
      }

      const cartBubble = await fetch(`${window.Shopify.routes.root}?sections=cart-icon-bubble`)
        .then((res) => res.json());

      document.getElementById('cart-icon-bubble').innerHTML = cartBubble['cart-icon-bubble'];
    } catch (err) {
        document.getElementById('add-to-cart-message').innerText = 'Failed to add item to cart. Please try again later.';
        const addToCartButton = document.getElementById('add-to-cart-button');
        if (addToCartButton) {
          addToCartButton.disabled = true;
        }
    }
  }

  /**
  * @returns the currently selected variant id based on the options selected
  */
  function getSelectedVariant(itemUuid) {
    try {
      if (itemUuid) {
        console.log(`Using item ${itemUuid}`);
        return Object.values(variantMap)[0];
      }
      const { variantId } = window.variants.getCurrentVariant() || {};
      if (variantId) {
        return variantMap[variantId.split('gid://shopify/ProductVariant/')[1]];
      }
      throw new Error('No variant found')
    } catch (err) {
      console.log(`Failed to find variant ${err}`);
      return null;
    }
  }

  /**
  * @returns the currently selected variant id based on the options selected
  */
  function getSelectedVariantId() {
    try{
      const { variantId } = window.variants.getCurrentVariant() || {};
      if (variantId) {
        return variantId.split('gid://shopify/ProductVariant/')[1];
      }
      throw new Error('No variant found')
    } catch (err) {
      console.log(`Failed to find variant ${err}`);
      return null;
    }
  }

  
  return {
    addToShopifyCart,
    getShopifyCart,
    getSelectedVariant,
    getSelectedVariantId,
  };
})();